import { render, staticRenderFns } from "./sailingHolidays.vue?vue&type=template&id=3ff60bd5&scoped=true"
import script from "./sailingHolidays.vue?vue&type=script&lang=js"
export * from "./sailingHolidays.vue?vue&type=script&lang=js"
import style0 from "./sailingHolidays.vue?vue&type=style&index=0&id=3ff60bd5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff60bd5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,VBreadcrumbs: require('/var/www/tubber-new/components/global/v/breadcrumbs.vue').default})
